import { BarChart, Bar, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { FONTS, COLORS } from "../constants/theme";

// ─── SpendIQ ───────────────────────────────────────────────────────────────────
// Persona: CFO
// Data sources: See constants/modules.js

const KPIs = [
  { label: "CAC (blended)", value: "$6,400", delta: "-22% YoY", color: "#059669" },
  { label: "LTV:CAC Ratio", value: "4.8x", delta: "Target: >3x", color: "#059669" },
  { label: "CAC Payback", value: "10 mo", delta: "-4mo YoY", color: "#059669" },
  { label: "S&M as % Rev", value: "38%", delta: "Down from 46%", color: "#059669" },
  { label: "Magic Number", value: "0.9", delta: "Target: >0.75", color: "#059669" },
  { label: "Rule of 40", value: "44", delta: "+8pts YoY", color: "#059669" }
];
const CHART_DATA = [
  {
    "month": "Jan",
    "Sales": 280,
    "Marketing": 190,
    "CS": 110
  },
  {
    "month": "Feb",
    "Sales": 290,
    "Marketing": 200,
    "CS": 115
  },
  {
    "month": "Mar",
    "Sales": 310,
    "Marketing": 185,
    "CS": 120
  },
  {
    "month": "Apr",
    "Sales": 320,
    "Marketing": 210,
    "CS": 118
  },
  {
    "month": "May",
    "Sales": 330,
    "Marketing": 220,
    "CS": 125
  },
  {
    "month": "Jun",
    "Sales": 340,
    "Marketing": 215,
    "CS": 130
  }
];

export default function SpendIQ({ module: mod, theme }) {
  const { surface, border, text, muted, dark } = theme;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {KPIs.map((k, i) => (
          <div key={i} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 12, padding: "16px 18px", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${mod.accent}55, ${mod.accent})` }} />
            <p style={{ color: muted, fontSize: 10, fontFamily: FONTS.mono, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</p>
            <p style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 22, color: text, letterSpacing: "-.02em" }}>{k.value}</p>
            <span style={{ display: "inline-block", marginTop: 6, fontFamily: FONTS.mono, fontSize: 10, padding: "2px 7px", borderRadius: 20, color: k.color, background: k.color + "18" }}>{k.delta}</span>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 14, padding: "20px 24px" }}>
        <p style={{ fontFamily: FONTS.mono, fontSize: 11, color: muted, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 16 }}>GTM Spend by Function ($K/mo)</p>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={CHART_DATA} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e243860" />
          <XAxis dataKey="month" tick={{ fill: "#8892b0", fontSize: 11 }} />
          <YAxis tick={{ fill: "#8892b0", fontSize: 11 }} />
          <Tooltip contentStyle={{ background: "#0a0e1a", border: "1px solid #1e2438", borderRadius: 8, fontSize: 11 }} />
          <Legend wrapperStyle={{ fontSize: 11, color: "#8892b0" }} />
          <Bar dataKey="Sales" fill="#b45309" radius={[4,4,0,0]} />
          <Bar dataKey="Marketing" fill="#d97706" radius={[4,4,0,0]} />
          <Bar dataKey="CS" fill="#0891b2" radius={[4,4,0,0]} />
        </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Insight */}
      <div style={{ background: mod.accent + "10", border: `1px solid ${mod.accent}25`, borderRadius: 12, padding: "14px 18px", display: "flex", gap: 12, alignItems: "flex-start" }}>
        <span style={{ color: mod.accent, fontSize: 16, flexShrink: 0, marginTop: 1 }}>◉</span>
        <div>
          <p style={{ fontFamily: FONTS.mono, fontSize: 10, color: mod.accent, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 4 }}>IQ INSIGHT</p>
          <p style={{ fontSize: 13, color: dark ? "#a0aec0" : "#475569", lineHeight: 1.65 }}>Sales spend growing at 10% MoM while pipeline coverage holding at 3.4x — healthy efficiency. Marketing CPL improving despite flat spend.</p>
        </div>
      </div>
    </div>
  );
}
